import { GenericMessage } from "./GenericMessage";
export const CloseMessage = new GenericMessage({ command: 'CLOSE' });
